import React from 'react';

function DataSkillList() {
  return (
    <> 
    <div class="row" width="100%"> 
    <h4>Data and Metadata Standards</h4>
     <div class="col">
        <ul>
          <li>JSON</li>
          <li>JSON-LD</li>
          <li>XML</li>
        </ul>
      </div>
      <div class="col">
        <ul>
          <li>MARC21</li>
          <li>Dublin Core</li>
          <li>DCRM</li>
        </ul>
      </div>
      <div class="col">
        <ul>
          <li>EAD</li>
          <li>RDF</li>
          <li>TEI</li>
        </ul>
      </div>
    </div> 
    </>
  )
};

export default DataSkillList;